import { LoginDataModel } from "../../models/Reducer.model";
import { ActionModel } from "../../models/General.model";
import { LANGUAGES } from "../../utils/constants/Constants";

export const initialStateVal: LoginDataModel = {
  userName: "",
  password: "",
  language: "en",
  loggedUserDetails: [],
  countriesDropDown: [],
  selectedCounty: {},
  initialCountry: {},
  roleId: 0,
  tokenDetails: {},
  sideMenuData: [],
};
const LoginReducer: any = (state = initialStateVal, action: ActionModel) => {
  switch (action.type) {
    case "updateLoginDetails":
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
      case "updateCountryDetails":
        localStorage.setItem("countryId", action.payload.value.getUserCountryLists?.[0]?.countryId);
        localStorage.setItem("adminType", JSON.stringify(action.payload.value.adminResponse?.[0]));
      return {
        ...state,
        countriesDropDown: action.payload.value.getUserCountryLists,
        selectedCounty: action.payload.value.getUserCountryLists?.[0] || {},
      };
    default:
      return state;
  }
};
export default LoginReducer;
